import { Injectable } from '@angular/core';

interface Scripts {
  name: string;
  src: string;
}

export const ScriptStore: Scripts[] = [
  { name: 'corejs', src: 'assets/dashboard/js/core.js' },
  { name: 'chartjs', src: 'assets/dashboard/js/charts.js' },
  { name: 'animatejs', src: 'assets/dashboard/js/animate.js' },
  { name: 'mediaRichAdvert', src: 'assets/mediaRichAdvert/js/JobAdvertPageTemplate.js' },
  { name: 'designer', src: 'assets/NewJT7/js/designer.js' },
  { name: 'switchery', src: 'assets/NewJT7/JTForms/switchery-master/switchery.js' },
  { name: 'jqueryUIJs', src: 'assets/NewJT7/js/jquery-ui.js' },
  { name: 'noteJs', src: 'assets/notesJT7/stickyNotesPlugins/Notes.js' },
  { name: 'spectrum', src: 'assets/GreenRoom/js/customSpectrum.js' },
  { name: 'polymarScript', src: 'https://cdn.polyfill.io/v2/polyfill.min.js' },
  { name: 'greenRoomTemplateScript', src: 'assets/GreenRoom/js/JtGreenRoomTemplateScript.js' },
  { name: 'pdf', src: 'assets/candidate/js/jspdf.js' },
  { name: 'htmltocanvas', src: 'assets/candidate/js/html2canvas.js' },
  { name: 'gaTag', src: 'https://www.googletagmanager.com/gtag/js?id=UA-142400835-1' },
  { name: 'ckeditor', src: 'assets/mediaRichAdvert/js/loadCkeditor.js' },

];

declare var document: any;
@Injectable({
  providedIn: 'root'
})
export class DynamicScriptLoaderService {

  private scripts: any = {};

  constructor() {

    ScriptStore.forEach((script: any) => {
      this.scripts[script.name] = {
        loaded: false,
        src: script.src
      };
    });
  }

  load(...scripts: string[]) {
    const promises: any[] = [];
    scripts.forEach((script) => promises.push(this.loadScript(script)));
    return Promise.all(promises);
  }

  loadScript(name: string) {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = this.scripts[name].src;
      script.id = name;
      if (script.readyState) { // IE
        script.onreadystatechange = () => {
          if (script.readyState === 'loaded' || script.readyState === 'complete') {
            script.onreadystatechange = null;
            this.scripts[name].loaded = true;
            resolve({ script: name, loaded: true, status: 'Loaded' });
          }
        };
      } else { // Others
        script.onload = () => {
          this.scripts[name].loaded = true;
          resolve({ script: name, loaded: true, status: 'Loaded' });
        };
      }
      script.onerror = (error: any) => resolve({ script: name, loaded: false, status: 'Loaded' });
      document.getElementsByTagName('head')[0].appendChild(script);

    });
  }
  removeScripts(...scriptsIds: string[]) {
    scriptsIds.forEach((script) => {
      this.removeScript(script)
    });
  }
  loadScriptBySource(src: string) {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = src;
      if (script.readyState) { // IE
        script.onreadystatechange = () => {
          if (script.readyState === 'loaded' || script.readyState === 'complete') {
            script.onreadystatechange = null;
            resolve({ script: name, loaded: true, status: 'Loaded' });
          }
        };
      } else { // Others
        script.onload = () => {
          resolve({ script: name, loaded: true, status: 'Loaded' });
        };
      }
      script.onerror = (error: any) => resolve({ script: name, loaded: false, status: 'Loaded' });
      document.getElementsByTagName('head')[0].appendChild(script);

    });
  }


  private removeScript(id: string): void {
    let element = document.getElementById(id);
    if (element) {
      element.parentNode?.removeChild(element);
    }
  }


}
